import { notification } from "antd";
import Helper from "../../Helper";
import { ProcurementView } from "../../models/ProcurementView";
import { plotFetch } from "../Helper/ApiRequest";
import { ChangeHistoryPoint } from "../Materials/materialTypes";

export function getMaterialAudits(team_subdomain: string, project_token: string): Promise<ChangeHistoryPoint[]> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/material_audits";

    return plotFetch(url, { method: "get" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            const history = new Array<ChangeHistoryPoint>();

            for (const point of response) {
                history.push(ChangeHistoryPoint.fromApiObject(point));
            }

            return history;
        })
        .catch(() => {
            notification.error({
                message: "Failed to get material audits",
                description: "Please try again later",
            });

            return [];
        });
}

export function getProcurementViews(
    subdomain: string,
    projectToken: string,
    timezone: string
): Promise<ProcurementView[]> {
    const url =
        Helper.baseUrlAltSubdomain(subdomain ? subdomain : "projects") +
        "/projects/" +
        projectToken +
        "/procurement_views";

    return plotFetch(url, { method: "get" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error("Network error.");
            }
        })
        .then((response) => {
            return response.map((view) => {
                return ProcurementView.fromApiObject(view, timezone);
            });
        })
        .catch(() => {
            notification.error({
                message: "Failed to get procurement views",
                description: "Please try again later",
            });

            return [];
        });
}

export function updateProcurementView(
    subdomain: string,
    projectToken: string,
    timezone: string,
    view: ProcurementView
): Promise<ProcurementView> {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/procurement_views/${view.id}`;
    return plotFetch(
        url,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(view.toApiObject()),
        },
        true
    )
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error("Network error.");
        })
        .then((response) => {
            return ProcurementView.fromApiObject(response, timezone);
        })
        .catch(() => {
            notification.error({
                message: "Failed to update procurement view",
                description: "Please try again later",
            });
            return view;
        });
}

export function createProcurementView(
    subdomain: string,
    projectToken: string,
    timezone: string,
    view: ProcurementView
): Promise<ProcurementView> {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/procurement_views/`;

    return plotFetch(url, { method: "POST", body: JSON.stringify(view.toApiObject()) }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error("Network error.");
        })
        .then((response) => {
            return ProcurementView.fromApiObject(response, timezone);
        })
        .catch(() => {
            notification.error({
                message: "Failed to create procurement view",
                description: "Please try again later",
            });
            return view;
        });
}

export function destroyProcurementView(subdomain: string, projectToken: string, view: ProcurementView): Promise<any> {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/procurement_views/${view.id}`;

    return plotFetch(url, { method: "delete" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error("Network error.");
        })
        .then((response) => {
            return Promise.resolve();
        })
        .catch(() => {
            notification.error({
                message: "Failed to delete procurement view",
                description: "Please try again later",
            });
            return view;
        });
}
